// fetch-polyfill 可以考虑，目前存在兼容性问题

// 提供xhr请求


function postData(options) {
  let xhr = null;

  xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    let readyState = xhr.readyState;
    let status = xhr.status;
    let callback = options.callback;

    if (readyState === 4) {
      if (status >= 200 && status < 300) { // success
        // try{
        let response = JSON.parse(xhr.responseText);
        callback && callback(response);
        // }catch(e){
        // console.error(e.toString());
        // }
      } else {
        let response;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (e) {
          response = null;
        }

        let error = options.error;
        error && error(response);
      }
    }
  }
  xhr.withCredentials = true;
  // method, url, async
  xhr.open('POST', options.url, !options.sync);
  if (options.form) {
    // xhr.setRequestHeader('Content-Type', 'multipart/form-data');
  } else {
    xhr.setRequestHeader('Content-Type', 'application/json');
  }

  // 身份校验
  let token = sessionStorage.getItem('x-fs-sf-token');
  token && xhr.setRequestHeader('x-fs-sf-token', token);

  xhr.send(options.data);
  return xhr;
}

export function valideImageCode(code, cid, callback) {
  postData({
    url: '/smartform/rest/extApi/data/captcha/validate',
    data: JSON.stringify({
      verifyCode: code,
      cid
    }),
    callback
  })
}

export function getCountryList(callback) {
  postData({
    url: '/smartform/rest/extApi/describe/country/list',
    data: JSON.stringify({
      lang: window.sLanguageType,
      tenantId: window.tenantId
    }),
    sync: true,
    callback: (response) => {
      let { code, data } = response;
      if (code === 0) {
        callback && callback(data);
      }
    }
  })
}

export function getZoneByParent(value,callback) {

  postData({
    url: '/smartform/rest/extApi/findZoneByParent',
    data: JSON.stringify(value),
    sync: true,
    callback: (response) => {
      let { code, data } = response;
      if (code === 0) {
        callback && callback(data);
      }
    }
  })
}

export function calPaymentAmount(value, callback) {
  postData({
    url: '/smartform/rest/extApi/data/expression/calculate',
    data: value,
    callback: (response) => {
      let { code, data } = response;
      if (code === 0) {
        callback && callback(data);
      }
    }
  })
}
export function getPayResult(value, callback) {
  var origin = window.location.origin || 'https://www.fxiaoke.com'
  postData({
    url: `${origin}/eapay/getEACollectOrderPayResultForWeb`,
    data: value,
    callback: (response) => {
      let { errorCode, payStatus } = response;
      if (errorCode === 0) {
        callback(payStatus);
      }
    }
  })
}

export default postData;



// WEBPACK FOOTER //
// ./src/assets/xhr.js